




























































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import numUtils from "@/utils/numUtils";
import CountDown from "@/components/countDown/CountDown.vue";
import * as types from "@/store/constants/types";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { isIos } from "@/utils/lodash";
import SkipDelayCount from "../skipDelayCount/SkipDelayCount.vue";
// import vipPriceText from "@/utils/vipOfferUtils";
import vipOfferUtils from "@/utils/vipOfferUtils";
// import * as Localized from "@/utils/localizedUtil.ts";
import { localizedPrice } from "@/utils/localizedUtil";

@Component({
  components: {
    CountDown,
    SkipDelayCount
  }
})
export default class FeedVip extends Vue {
  @Prop({ default: 0 })
  private vipCountDownTime?: number;
  @Getter(types.GETTER_INFO_BY_OFFER_DATA) private offerInfo: any;
  @Action(types.ROUTER_PUSH) private routerPush: any;
  @Getter(types.GETTER_LOCALIZE_PRICE) private localizePrice: any;
  @Getter(types.GETTER_SETTING_DATA) private settginData: any;
  @Prop({
    default: () => {
      return null;
    }
  })
  private offer: any;
  @Prop({ default: 0 })
  private skipDelayCountNum!: number;

  private uiStatus: string = "carousel"; //carousel single

  private swiperOption: any = {
    // some swiper options/callbacks
    // 所有的参数同 swiper 官方 api 参数
    // ...
    autoplay: {
      disableOnInteraction: false
    },
    pagination: {
      el: ".more-vip-swiper-pagination"
    }
  };

  get priceText() {
    return vipOfferUtils.vipPriceText();
  }

  get localizedPrice() {
    return localizedPrice;
  }

  private vipList = [
    {
      icon: require("@/assets/icons-file/more/10_bonus@3x.png"),
      title: "10 Daily Bonus Followers",
      content: `+10 golden followers (<span>worth ${this.localizedPrice(
        this.priceText.dayMoney
      )}</span>) <span>every day</span> to keep your followers growing steadily (totally <span>worth ${this.localizedPrice(
        this.priceText.monthMoney
      )}/month</span>)⚡️⚡️⚡️`
    },
    {
      icon: require("@/assets/icons-file/more/tab51000bonuscoins.png"),
      title: "1,000 Bonus Coins",
      content: `Get 1,000 free bonus coins (<span>worth ${this.localizedPrice(
        "9.99"
      )} </span>) as a welcome gift!`
    },
    {
      icon: require("@/assets/icons-file/more/more_bonus.png"),
      title: "10% More on All 👤 ❤️ Orders",
      content: `<span>Exclusive 10% bonus</span> for all followers, likes, comments and views orders.`
    },
    {
      icon: require("@/assets/icons-file/more/ico_tab5_exclusivevipdiscount@3x.png"),
      title: "Exclusive VIP Discount",
      content: `<span>4 super big discount</span> coins packages exclusive for VIP member every month (<span>save ${this.localizedPrice(
        vipOfferUtils.vipSaveMoney()
      )}/month</span>)!`
    },
    {
      icon: require("@/assets/icons-file/more/no_folllowers_drop@3x.png"),
      title: `No Followers Drop <span>🔰</span>`,
      content: `We will <span>compensate</span> you with <span>extra followers</span> if anyone unfollows you in the first week.`
    },
    {
      icon: require("@/assets/icons-file/more/ico_tab5_moreactive@2x.png"),
      title: "More Active & Real Followers",
      content: `See great growth in <span>more real, passionate, interested and engaged</span> followers.`
    },
    {
      icon: require("@/assets/icons-file/more/faster@3x.png"),
      title: "300% Higher-Speed Growth",
      content: `Your <span>orders</span> of followers, likes or views will be delivered <span>300% faster</span> than non-VIP members.`
    },
    {
      icon: require("@/assets/icons-file/more/ico_tab5_24personalconsultant@3x.png"),
      title: "24/7  Personal Consultant",
      content: `Your personal consultant is <span>available 24/7</span> to assist with all your needs.`
    },
    {
      icon: require("@/assets/icons-file/more/ads@3x.png"),
      title: "Remove ADS",
      content: `Enjoy a completely <span>AD FREE</span> experience.`
    }
  ];

  private clickVipBenefits() {
    this.routerPush({
      name: "VipCenter",
      params: {
        routerTransition: "up",
        type: "multiple"
      },
      query: {
        type: "multiple"
      }
    });
  }

  private created() {}

  private mounted() {
    //每次显示有两种形态
    // const randomNum = Math.random() * 100;
    // if (randomNum > 50) {
    //   this.uiStatus = "single";
    // }
  }
}
